import { createVNode as _createVNode, resolveComponent as _resolveComponent, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelText as _vModelText, vModelRadio as _vModelRadio } from "vue"

const _hoisted_1 = { class: "modal-wrap default-modal xl-size" }
const _hoisted_2 = {
  class: "modal fade default-modal",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "chatChannelInviteMember",
  tabindex: "-1",
  "aria-labelledby": "chatChannelInviteMember",
  "aria-hidden": "true"
}
const _hoisted_3 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "d-block" }, [
  /*#__PURE__*/_createVNode("h5", {
    class: "modal-title",
    id: "exampleModalLabel"
  }, " Invite member "),
  /*#__PURE__*/_createVNode("p", { class: "text-muted" }, " Create project to collaborate with other members. ")
], -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_8 = { class: "modal-body" }
const _hoisted_9 = { class: "form-group pt-0" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "inline-items" }
const _hoisted_12 = {
  key: 0,
  class: "form-group"
}
const _hoisted_13 = { class: "custom-control custom-switch mr-3" }
const _hoisted_14 = /*#__PURE__*/_createVNode("label", {
  class: "custom-control-label",
  for: "guestSwitch"
}, "As Guest", -1)
const _hoisted_15 = {
  key: 0,
  class: "from-group"
}
const _hoisted_16 = { class: "custom-control custom-switch mr-3" }
const _hoisted_17 = /*#__PURE__*/_createVNode("label", {
  class: "custom-control-label",
  for: "guestSwitch1"
}, "As Public User", -1)
const _hoisted_18 = {
  key: 0,
  class: "alert alert-danger text-center",
  role: "alert"
}
const _hoisted_19 = /*#__PURE__*/_createVNode("p", { class: "mb-0" }, [
  /*#__PURE__*/_createVNode("small", null, "You currently don't own a channel; hence you cannot add a member.")
], -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("p", { class: "mb-0" }, [
  /*#__PURE__*/_createVNode("small", null, "Start with creating a channel.")
], -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("i", { class: "fa fa-plus" }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Create Channel ")
const _hoisted_23 = {
  key: 1,
  class: "form-group"
}
const _hoisted_24 = /*#__PURE__*/_createVNode("label", { for: "exampleInputEmail1" }, "Invite Existing member", -1)
const _hoisted_25 = { class: "mb-0" }
const _hoisted_26 = /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt" }, null, -1)
const _hoisted_27 = {
  key: 2,
  class: "form-group"
}
const _hoisted_28 = /*#__PURE__*/_createVNode("label", { for: "exampleInputEmail1" }, "Invite new member", -1)
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { key: 1 }
const _hoisted_31 = {
  key: 2,
  class: "table-wrap table-responsive mb-3"
}
const _hoisted_32 = { class: "table table-bordered table-shadowed font-12" }
const _hoisted_33 = /*#__PURE__*/_createVNode("thead", { class: "table-primary nowrap-text" }, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("td", null, "First Name"),
    /*#__PURE__*/_createVNode("td", null, "Last Name"),
    /*#__PURE__*/_createVNode("td", null, "Mobile Number"),
    /*#__PURE__*/_createVNode("td", null, "Email "),
    /*#__PURE__*/_createVNode("td", null, "Notify By"),
    /*#__PURE__*/_createVNode("td", null, "Action")
  ])
], -1)
const _hoisted_34 = { class: "form-group" }
const _hoisted_35 = { class: "form-group" }
const _hoisted_36 = { class: "form-group" }
const _hoisted_37 = { class: "input-group" }
const _hoisted_38 = { class: "form-group" }
const _hoisted_39 = { class: "form-group" }
const _hoisted_40 = {
  class: "notify-by-form-group",
  id: "notifyByFormGroup"
}
const _hoisted_41 = { class: "form-check form-check-inline" }
const _hoisted_42 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "inlineCheckbox1"
}, "Email", -1)
const _hoisted_43 = { class: "form-check form-check-inline" }
const _hoisted_44 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "inlineCheckbox2"
}, "SMS", -1)
const _hoisted_45 = { class: "text-nowrap" }
const _hoisted_46 = /*#__PURE__*/_createVNode("i", { class: "fa fa-plus" }, null, -1)
const _hoisted_47 = /*#__PURE__*/_createTextVNode(" Add")
const _hoisted_48 = /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt" }, null, -1)
const _hoisted_49 = /*#__PURE__*/_createTextVNode(" Delete")
const _hoisted_50 = /*#__PURE__*/_createVNode("h5", { class: "modal-title" }, "Include Conversation History ?", -1)
const _hoisted_51 = /*#__PURE__*/_createVNode("p", { class: "text-muted" }, "Choose whether the listed user can see past messages and files once they're added to the conversation. ", -1)
const _hoisted_52 = { class: "form-group mt-3" }
const _hoisted_53 = { class: "custom-control custom-radio custom-control-inline" }
const _hoisted_54 = /*#__PURE__*/_createVNode("label", {
  class: "custom-control-label",
  for: "customRadioInline1"
}, "From Invitation Accepted", -1)
const _hoisted_55 = { class: "custom-control custom-radio custom-control-inline" }
const _hoisted_56 = /*#__PURE__*/_createVNode("label", {
  class: "custom-control-label",
  for: "customRadioInline2"
}, "From Today", -1)
const _hoisted_57 = { class: "custom-control custom-radio custom-control-inline" }
const _hoisted_58 = /*#__PURE__*/_createVNode("label", {
  class: "custom-control-label",
  for: "customRadioInline3"
}, "From The Beginning", -1)
const _hoisted_59 = { class: "custom-control custom-radio custom-control-inline" }
const _hoisted_60 = /*#__PURE__*/_createVNode("label", {
  class: "custom-control-label",
  for: "customRadioInline4"
}, "Custom", -1)
const _hoisted_61 = {
  key: 3,
  class: "row"
}
const _hoisted_62 = { class: "col-md-3" }
const _hoisted_63 = { class: "form-group" }
const _hoisted_64 = {
  key: 3,
  class: "form-group"
}
const _hoisted_65 = /*#__PURE__*/_createVNode("label", { for: "exampleInputEmail1" }, "Invite new member by Email & Number", -1)
const _hoisted_66 = { class: "col-lg-2" }
const _hoisted_67 = { class: "form-group" }
const _hoisted_68 = /*#__PURE__*/_createVNode("label", { for: "exampleFullName" }, "Full Name", -1)
const _hoisted_69 = { class: "col-lg-3" }
const _hoisted_70 = { class: "form-group" }
const _hoisted_71 = /*#__PURE__*/_createVNode("label", { for: "exampleEmailInput" }, "Email", -1)
const _hoisted_72 = { class: "col-lg-3" }
const _hoisted_73 = { class: "form-group" }
const _hoisted_74 = /*#__PURE__*/_createVNode("label", { for: "exampleMobileNumber" }, "Mobile Number", -1)
const _hoisted_75 = { class: "input-group" }
const _hoisted_76 = /*#__PURE__*/_createVNode("div", { class: "input-group-prepend" }, [
  /*#__PURE__*/_createVNode("span", { class: "input-group-text" }, "+1")
], -1)
const _hoisted_77 = { class: "col-lg-2" }
const _hoisted_78 = /*#__PURE__*/_createVNode("label", { for: "notifyByFormGroup" }, "Notify By", -1)
const _hoisted_79 = {
  class: "notify-by-form-group",
  id: "notifyByFormGroup"
}
const _hoisted_80 = { class: "form-check form-check-inline" }
const _hoisted_81 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "inlineCheckbox1"
}, "Email", -1)
const _hoisted_82 = { class: "form-check form-check-inline" }
const _hoisted_83 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "inlineCheckbox2"
}, "SMS", -1)
const _hoisted_84 = { class: "col-lg-2" }
const _hoisted_85 = /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_86 = /*#__PURE__*/_createTextVNode(" Add ")
const _hoisted_87 = /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt" }, null, -1)
const _hoisted_88 = /*#__PURE__*/_createTextVNode(" Delete")
const _hoisted_89 = { class: "mb-0" }
const _hoisted_90 = /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt" }, null, -1)
const _hoisted_91 = /*#__PURE__*/_createTextVNode(" Delete")
const _hoisted_92 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorList = _resolveComponent("ErrorList")
  const _component_multiselect = _resolveComponent("multiselect")
  const _component_AppPhoneNumberInput = _resolveComponent("AppPhoneNumberInput")
  const _component_v_date_picker = _resolveComponent("v-date-picker")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode("button", {
              type: "button",
              class: "close",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.hideChatChannelInviteMember && _ctx.hideChatChannelInviteMember(...args))),
              "aria-label": "Close"
            }, [
              _hoisted_7
            ])
          ]),
          _createVNode("div", _hoisted_8, [
            _createVNode("div", _hoisted_9, [
              _createVNode(_component_ErrorList, {
                errors: _ctx.state.ui.errors.errorList.errorList,
                hasError: _ctx.state.ui.errors.hasError
              }, null, 8, ["errors", "hasError"]),
              (!_ctx.state.data.invitationVerify.showStatus)
                ? (_openBlock(), _createBlock("div", _hoisted_10, [
                    _createVNode("div", _hoisted_11, [
                      _createVNode("ul", null, [
                        _createVNode("li", null, [
                          (!_ctx.state.data.inviteAsPublicUser)
                            ? (_openBlock(), _createBlock("div", _hoisted_12, [
                                _createVNode("div", _hoisted_13, [
                                  _withDirectives(_createVNode("input", {
                                    type: "checkbox",
                                    class: "custom-control-input",
                                    id: "guestSwitch",
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.data.inviteAsGuest = $event))
                                  }, null, 512), [
                                    [_vModelCheckbox, _ctx.state.data.inviteAsGuest]
                                  ]),
                                  _hoisted_14
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createVNode("li", null, [
                          (!_ctx.state.data.inviteAsGuest)
                            ? (_openBlock(), _createBlock("div", _hoisted_15, [
                                _createVNode("div", _hoisted_16, [
                                  _withDirectives(_createVNode("input", {
                                    type: "checkbox",
                                    class: "custom-control-input",
                                    id: "guestSwitch1",
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.data.inviteAsPublicUser = $event))
                                  }, null, 512), [
                                    [_vModelCheckbox, _ctx.state.data.inviteAsPublicUser]
                                  ]),
                                  _hoisted_17
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    (!_ctx.state.data.showCheckChannelMessage)
                      ? (_openBlock(), _createBlock("div", _hoisted_18, [
                          _hoisted_19,
                          _hoisted_20,
                          _createVNode("p", null, [
                            (_ctx.isUserStatus)
                              ? (_openBlock(), _createBlock("a", {
                                  key: 0,
                                  href: "javascript:void(0)",
                                  class: "btn default-btn mt-2",
                                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.showCreateProjectChannel && _ctx.showCreateProjectChannel(...args)))
                                }, [
                                  _hoisted_21,
                                  _hoisted_22
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.state.data.inviteAsGuest &&
                  !_ctx.state.data.inviteAsPublicUser
                )
                      ? (_openBlock(), _createBlock("div", _hoisted_23, [
                          _hoisted_24,
                          _createVNode(_component_multiselect, {
                            modelValue: _ctx.selectedUsers,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectedUsers = $event)),
                            options: _ctx.allUsers,
                            "custom-label": _ctx.nameWithEmail,
                            "close-on-select": "true",
                            "clear-on-select": true,
                            placeholder: "Search and select",
                            label: "email",
                            "track-by": "email",
                            onSelect: _cache[6] || (_cache[6] = ($event: any) => (_ctx.selectToChangeUsers(_ctx.selectedUsers)))
                          }, null, 8, ["modelValue", "options", "custom-label"]),
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.invite.users, (user, userIndex) => {
                            return (_openBlock(), _createBlock("div", {
                              class: "email-tag",
                              key: userIndex
                            }, [
                              _createVNode("p", _hoisted_25, [
                                _createTextVNode(_toDisplayString(user.full_name) + " (" + _toDisplayString(user.email) + ") ", 1),
                                _createVNode("a", {
                                  href: "javascript:void(0)",
                                  onClick: ($event: any) => (_ctx.removeSelectedMember(user))
                                }, [
                                  _hoisted_26
                                ], 8, ["onClick"])
                              ])
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.state.data.inviteAsPublicUser)
                      ? (_openBlock(), _createBlock("div", _hoisted_27, [
                          _hoisted_28,
                          (_ctx.state.inputError)
                            ? (_openBlock(), _createBlock("p", _hoisted_29, "Please fill below field"))
                            : _createCommentVNode("", true),
                          (_ctx.state.duplicate)
                            ? (_openBlock(), _createBlock("p", _hoisted_30, "This email is already used below"))
                            : _createCommentVNode("", true),
                          (_ctx.state.invite.invites && _ctx.state.invite.invites.length)
                            ? (_openBlock(), _createBlock("div", _hoisted_31, [
                                _createVNode("table", _hoisted_32, [
                                  _hoisted_33,
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.invite.invites, (invite, inviteIndex) => {
                                    return (_openBlock(), _createBlock("tbody", { key: inviteIndex }, [
                                      _createVNode("tr", null, [
                                        _createVNode("td", null, [
                                          _createVNode("div", _hoisted_34, [
                                            _withDirectives(_createVNode("input", {
                                              type: "text",
                                              class: invite.fNameError ? 'form-control error-field' : 'form-control',
                                              "onUpdate:modelValue": ($event: any) => (invite.first_name = $event)
                                            }, null, 10, ["onUpdate:modelValue"]), [
                                              [_vModelText, invite.first_name]
                                            ])
                                          ])
                                        ]),
                                        _createVNode("td", null, [
                                          _createVNode("div", _hoisted_35, [
                                            _withDirectives(_createVNode("input", {
                                              type: "text",
                                              class: invite.lNameError ? 'form-control error-field' : 'form-control',
                                              "onUpdate:modelValue": ($event: any) => (invite.last_name = $event)
                                            }, null, 10, ["onUpdate:modelValue"]), [
                                              [_vModelText, invite.last_name]
                                            ])
                                          ])
                                        ]),
                                        _createVNode("td", null, [
                                          _createVNode("div", _hoisted_36, [
                                            _createVNode("div", _hoisted_37, [
                                              _createVNode(_component_AppPhoneNumberInput, {
                                                modelValue: invite.phone,
                                                "onUpdate:modelValue": ($event: any) => (invite.phone = $event),
                                                onInput: ($event: any) => (_ctx.checkEmptyFields(inviteIndex, 'phone'))
                                              }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                                            ])
                                          ])
                                        ]),
                                        _createVNode("td", null, [
                                          _createVNode("div", _hoisted_38, [
                                            _withDirectives(_createVNode("input", {
                                              type: "email",
                                              class: "form-control",
                                              "onUpdate:modelValue": ($event: any) => (invite.email = $event),
                                              onInput: ($event: any) => (_ctx.checkEmptyFields(inviteIndex, 'email'))
                                            }, null, 40, ["onUpdate:modelValue", "onInput"]), [
                                              [_vModelText, invite.email]
                                            ])
                                          ])
                                        ]),
                                        _createVNode("td", null, [
                                          _createVNode("div", _hoisted_39, [
                                            _createVNode("div", _hoisted_40, [
                                              _createVNode("div", _hoisted_41, [
                                                _withDirectives(_createVNode("input", {
                                                  class: "form-check-input",
                                                  type: "checkbox",
                                                  id: "inlineCheckbox1",
                                                  value: "true",
                                                  "onUpdate:modelValue": ($event: any) => (invite.mailNotification = $event)
                                                }, null, 8, ["onUpdate:modelValue"]), [
                                                  [_vModelCheckbox, invite.mailNotification]
                                                ]),
                                                _hoisted_42
                                              ]),
                                              _createVNode("div", _hoisted_43, [
                                                _withDirectives(_createVNode("input", {
                                                  class: "form-check-input",
                                                  type: "checkbox",
                                                  id: "inlineCheckbox2",
                                                  value: "true",
                                                  "onUpdate:modelValue": ($event: any) => (invite.smsNotification = $event)
                                                }, null, 8, ["onUpdate:modelValue"]), [
                                                  [_vModelCheckbox, invite.smsNotification]
                                                ]),
                                                _hoisted_44
                                              ])
                                            ])
                                          ])
                                        ]),
                                        _createVNode("td", _hoisted_45, [
                                          (_ctx.state.invite.invites.length === inviteIndex + 1)
                                            ? (_openBlock(), _createBlock("button", {
                                                key: 0,
                                                type: "button",
                                                class: "btn btn-sm text-primary mr-1",
                                                disabled: !_ctx.hasValidLastContact,
                                                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.addNewMember && _ctx.addNewMember(...args)))
                                              }, [
                                                _hoisted_46,
                                                _hoisted_47
                                              ], 8, ["disabled"]))
                                            : _createCommentVNode("", true),
                                          (_ctx.state.invite.invites.length != 1)
                                            ? (_openBlock(), _createBlock("a", {
                                                key: 1,
                                                title: "Delete",
                                                href: "javascript:void(0)",
                                                class: "btn btn-sm text-danger",
                                                disabled: _ctx.state.invite.invites.length === 1,
                                                onClick: ($event: any) => (_ctx.removeSelectedUser(invite))
                                              }, [
                                                _hoisted_48,
                                                _hoisted_49
                                              ], 8, ["disabled", "onClick"]))
                                            : _createCommentVNode("", true)
                                        ])
                                      ])
                                    ]))
                                  }), 128))
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          _hoisted_50,
                          _hoisted_51,
                          _createVNode("div", _hoisted_52, [
                            _createVNode("div", _hoisted_53, [
                              _withDirectives(_createVNode("input", {
                                type: "radio",
                                id: "customRadioInline1",
                                name: "customRadioInline",
                                value: "1",
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.selectedValue = $event)),
                                class: "custom-control-input"
                              }, null, 512), [
                                [_vModelRadio, _ctx.selectedValue]
                              ]),
                              _hoisted_54
                            ]),
                            _createVNode("div", _hoisted_55, [
                              _withDirectives(_createVNode("input", {
                                type: "radio",
                                id: "customRadioInline2",
                                name: "customRadioInline",
                                value: "2",
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.selectedValue = $event)),
                                class: "custom-control-input"
                              }, null, 512), [
                                [_vModelRadio, _ctx.selectedValue]
                              ]),
                              _hoisted_56
                            ]),
                            _createVNode("div", _hoisted_57, [
                              _withDirectives(_createVNode("input", {
                                type: "radio",
                                id: "customRadioInline3",
                                name: "customRadioInline",
                                value: "3",
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.selectedValue = $event)),
                                class: "custom-control-input"
                              }, null, 512), [
                                [_vModelRadio, _ctx.selectedValue]
                              ]),
                              _hoisted_58
                            ]),
                            _createVNode("div", _hoisted_59, [
                              _withDirectives(_createVNode("input", {
                                type: "radio",
                                id: "customRadioInline4",
                                name: "customRadioInline",
                                value: "4",
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.selectedValue = $event)),
                                class: "custom-control-input"
                              }, null, 512), [
                                [_vModelRadio, _ctx.selectedValue]
                              ]),
                              _hoisted_60
                            ])
                          ]),
                          (_ctx.selectedValue === '4')
                            ? (_openBlock(), _createBlock("div", _hoisted_61, [
                                _createVNode("div", _hoisted_62, [
                                  _createVNode("div", _hoisted_63, [
                                    _createVNode(_component_v_date_picker, {
                                      modelValue: _ctx.selectedDateForMember,
                                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.selectedDateForMember = $event))
                                    }, null, 8, ["modelValue"])
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : (_openBlock(), _createBlock("div", _hoisted_64, [
                          _hoisted_65,
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.inviteAsPublic, (publicMember, indexPublicMember) => {
                            return (_openBlock(), _createBlock("div", {
                              class: "row mb-3 align-items-center",
                              key: indexPublicMember
                            }, [
                              _createVNode("div", _hoisted_66, [
                                _createVNode("div", _hoisted_67, [
                                  _hoisted_68,
                                  _withDirectives(_createVNode("input", {
                                    type: "text",
                                    class: "form-control",
                                    id: "exampleFullName",
                                    placeholder: "Your Full Name",
                                    "onUpdate:modelValue": ($event: any) => (publicMember.name = $event)
                                  }, null, 8, ["onUpdate:modelValue"]), [
                                    [_vModelText, publicMember.name]
                                  ])
                                ])
                              ]),
                              _createVNode("div", _hoisted_69, [
                                _createVNode("div", _hoisted_70, [
                                  _hoisted_71,
                                  _withDirectives(_createVNode("input", {
                                    type: "email",
                                    class: "form-control",
                                    id: "exampleEmailInput",
                                    placeholder: "abc@convorally.com",
                                    "onUpdate:modelValue": ($event: any) => (publicMember.email = $event)
                                  }, null, 8, ["onUpdate:modelValue"]), [
                                    [_vModelText, publicMember.email]
                                  ])
                                ])
                              ]),
                              _createVNode("div", _hoisted_72, [
                                _createVNode("div", _hoisted_73, [
                                  _hoisted_74,
                                  _createVNode("div", _hoisted_75, [
                                    _hoisted_76,
                                    _withDirectives(_createVNode("input", {
                                      type: "number",
                                      class: "form-control",
                                      id: "exampleMobileNumber",
                                      placeholder: "mobile number only",
                                      "onUpdate:modelValue": ($event: any) => (publicMember.phone = $event)
                                    }, null, 8, ["onUpdate:modelValue"]), [
                                      [_vModelText, publicMember.phone]
                                    ])
                                  ])
                                ])
                              ]),
                              _createVNode("div", _hoisted_77, [
                                _hoisted_78,
                                _createVNode("div", _hoisted_79, [
                                  _createVNode("div", _hoisted_80, [
                                    _withDirectives(_createVNode("input", {
                                      class: "form-check-input",
                                      type: "checkbox",
                                      id: "inlineCheckbox1",
                                      value: "false",
                                      "onUpdate:modelValue": ($event: any) => (publicMember.mailNotification = $event)
                                    }, null, 8, ["onUpdate:modelValue"]), [
                                      [_vModelCheckbox, publicMember.mailNotification]
                                    ]),
                                    _hoisted_81
                                  ]),
                                  _createVNode("div", _hoisted_82, [
                                    _withDirectives(_createVNode("input", {
                                      class: "form-check-input",
                                      type: "checkbox",
                                      id: "inlineCheckbox2",
                                      value: "false",
                                      "onUpdate:modelValue": ($event: any) => (publicMember.smsNotification = $event)
                                    }, null, 8, ["onUpdate:modelValue"]), [
                                      [_vModelCheckbox, publicMember.smsNotification]
                                    ]),
                                    _hoisted_83
                                  ])
                                ])
                              ]),
                              _createVNode("div", _hoisted_84, [
                                (indexPublicMember + 1 ==
                        _ctx.state.inviteAsPublic.length ||
                        _ctx.state.inviteAsPublic.length === 1
                      )
                                  ? (_openBlock(), _createBlock("button", {
                                      key: 0,
                                      class: "btn default-btn mr-1",
                                      onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.changeInvitePublicMember && _ctx.changeInvitePublicMember(...args)))
                                    }, [
                                      _hoisted_85,
                                      _hoisted_86
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.state.inviteAsPublic &&
                        _ctx.state.inviteAsPublic.length > 1
                      )
                                  ? (_openBlock(), _createBlock("a", {
                                      key: 1,
                                      class: "btn btn-danger",
                                      onClick: ($event: any) => (_ctx.deletePublicMember(publicMember)),
                                      href: "javascript:void(0)"
                                    }, [
                                      _hoisted_87,
                                      _hoisted_88
                                    ], 8, ["onClick"]))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          }), 128)),
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.invite.invites, (invite, inviteIndex) => {
                            return (_openBlock(), _createBlock("div", {
                              key: inviteIndex,
                              class: "email-tag"
                            }, [
                              _createVNode("p", _hoisted_89, [
                                _createTextVNode(_toDisplayString(invite) + " ", 1),
                                _createVNode("a", {
                                  href: "javascript:void(0)",
                                  onClick: ($event: any) => (_ctx.removeSelectedUser(invite))
                                }, [
                                  _hoisted_90,
                                  _hoisted_91
                                ], 8, ["onClick"])
                              ])
                            ]))
                          }), 128))
                        ]))
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode("div", _hoisted_92, [
            _createVNode("div", null, [
              _createVNode("a", {
                href: "javascript:void(0)",
                class: "btn secondary-btn mr-2",
                onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.hideChatChannelInviteMember && _ctx.hideChatChannelInviteMember(...args)))
              }, "Cancel"),
              (_ctx.state.data.inviteAsPublicUser)
                ? (_openBlock(), _createBlock("a", {
                    key: 0,
                    href: "javascript:void(0)",
                    class: "btn default-btn",
                    onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.inviteAllPublicUser && _ctx.inviteAllPublicUser(...args)))
                  }, "Send"))
                : (_openBlock(), _createBlock("a", {
                    key: 1,
                    href: "javascript:void(0)",
                    class: "btn default-btn",
                    onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.inviteAllUsers && _ctx.inviteAllUsers(...args)))
                  }, _toDisplayString(_ctx.state.ui.isPostLoading.inviteAllUsers ? "Sending..." : "Send"), 1))
            ])
          ])
        ])
      ])
    ])
  ]))
}